import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { ReactNode, useEffect, useState } from "react";
import { IconLeftArrow, IconRightArrow } from "../../icons";
import InputSelect from "../Input-select";

interface ButtonNavigatorComponent {
  list: any[];
  page: number;
  setPage: any;
  selectSize: number;
  setSelectSize: any;
  label?: string;
  className?: string;
  selectSizeView?: boolean;
  setPageFirstRender?: boolean;
  ExtraContent?: () => ReactJSXElement;
}

const SIZELIST = [
  { id: 5, name: "5" },
  { id: 10, name: "10" },
  { id: 15, name: "15" },
];

export default function ButtonNavigatorComponent({
  list,
  page,
  selectSize,
  setSelectSize,
  setPage,
  label,
  className,
  selectSizeView = true,
  setPageFirstRender = true,
  ExtraContent,
}: ButtonNavigatorComponent) {
  const [nextButtonDisable, setNextButtonDisable] = useState(false);
  const [previousButtonDisable, setPreviousButtonDisable] = useState(true);
  const [pages, setPages] = useState([]);

  useEffect(() => {
    generateDinamicPages();
    if (setPageFirstRender) setPage(0);
    if (list?.length <= Number(selectSize)) return setNextButtonDisable(true);
    if ((page + 2) * Number(selectSize) > list?.length) return setNextButtonDisable(false);
  }, [list, selectSize]);


  useEffect(() => {
    currentPage();
  }, [page]);

  function handlePage(index: number) {
    setPage(index - 1);
    if (index - 1 !== 0) setPreviousButtonDisable(false);
    if (index - 1 === 0) setPreviousButtonDisable(true);
    if (pages?.length === index) setNextButtonDisable(true);
    if (pages?.length !== index) setNextButtonDisable(false);
  }

  function handleNextPage() {
    if ((page + 1) * selectSize >= list?.length) return;
    if ((page + 3) * selectSize >= list?.length) setNextButtonDisable(true);
    setPage(page + 1);
    setPreviousButtonDisable(false);
  }

  function handlePreviousPage() {
    if (page === 0) return;
    if (page === 1) setPreviousButtonDisable(true);
    setPage(page - 1);
    setNextButtonDisable(false);
  }

  function generateDinamicPages() {
    let data: any = [];

    let pagesCut =
      list?.length % selectSize <= 5 && list?.length % selectSize > 0 ? Math.ceil(list?.length / selectSize) : Math.ceil(list?.length / selectSize);

    for (let i = 1; i <= pagesCut; i++) {
      data.push(i);
    }
    setPages(data);
  }

  function currentPage() {
    const data = pages?.map((pageMap) => {
      if (pageMap === page - 1 || pageMap === page || pageMap === page + 1 || pageMap === page + 2 || pageMap === page + 3) return pageMap;
    });
    return data;
  }

  return (
    <div className={`navigator-container border-radius-bottom box-shadow between ${className}`}>
      {selectSizeView && (
        <InputSelect
          className="width-none select-navigator"
          label={label || "Nº de linhas"}
          name="selectSize"
          value={selectSize}
          list={SIZELIST}
          onChange={(e: any) => {
            setSelectSize(e.target.value);
          }}
        />
      )}

      {ExtraContent ? <ExtraContent /> : ""}

      <div className="navigator-container-components">
        {previousButtonDisable ? (
          <button type="button" className="N-disabled bg-none">
            {IconLeftArrow}
          </button>
        ) : (
          <button type="button" className="bg-none" onClick={handlePreviousPage}>
            {IconLeftArrow}
          </button>
        )}

        {list?.length < selectSize ? (
          <span className={`page-number`}>1</span>
        ) : (
          currentPage()?.map((pageCurrent: any) => {
            return (
              pageCurrent !== undefined && (
                <span onClick={() => handlePage(pageCurrent)} className={`${page + 1 === pageCurrent ? "page-number" : "page-not-current"}  pointer`}>
                  {pageCurrent}
                </span>
              )
            );
          })
        )}

        {nextButtonDisable ? (
          <button type="button" className="N-disabled bg-none">
            {IconRightArrow}
          </button>
        ) : (
          <button type="button" className="bg-none" onClick={handleNextPage}>
            {IconRightArrow}
          </button>
        )}
      </div>
    </div>
  );
}
